// This icon file is generated automatically.

import { IconDefinition } from '../types';

const SandClockFilled: IconDefinition = {
  icon: {
    tag: 'svg',
    attrs: {
      fill: 'currentColor',
      viewBox: '0 0 60 76',
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
    },
    children: [
      {
        tag: 'path',
        attrs: {
          d: 'M13.62 70h32.77V58q0-6.83-4.78-11.69A15.7 15.7 0 0 0 30 41.47q-6.83 0-11.6 4.85A16 16 0 0 0 13.61 58zM0 76v-6h7.62V58q0-6.75 3.7-12.3A19.3 19.3 0 0 1 21.1 38a19.5 19.5 0 0 1-9.8-7.72A21.6 21.6 0 0 1 7.61 18V6H0V0h60v6h-7.62v12q0 6.76-3.7 12.28A19.5 19.5 0 0 1 38.9 38q6.1 2.16 9.8 7.7t3.7 12.3v12H60v6z',
        },
      },
    ],
  },
  name: 'sand-clock',
  theme: 'filled',
};

export default SandClockFilled;
